/* eslint-disable max-len */
import styled from '@emotion/styled';
import {css, Theme} from '@emotion/react';
import {Link} from 'react-router-dom';

import {
  IconWrapper as IconWrapperStyle,
  TextDefault,
} from '../../styles/styles';

import {ReactComponent as DashboardSVG} from '../../../assets/icons/ic_dashboard.svg';
import {ReactComponent as SubscriptionSVG} from '../../../assets/icons/ic_subscription.svg';
import {ReactComponent as LoanSVG} from '../../../assets/icons/ic_loan.svg';
import {ReactComponent as LibrarySVG} from '../../../assets/icons/ic_library.svg';
import {ReactComponent as ProfileSVG} from '../../../assets/icons/ic_profile.svg';
import {ReactComponent as LanguageSVG} from '../../../assets/icons/ic_language.svg';
import {ReactComponent as ContactSVG} from '../../../assets/icons/ic_help.svg';
import {ReactComponent as LogoutVG} from '../../../assets/icons/ic_logout.svg';

export const MenuContainer = styled.div<{ level?: number }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: ${(props) => props.level ? `${props.level * 16}px` : '0'};
`;

export const SubMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: -4px;
`;

const iconStyle = ({theme}: {theme: Theme}) => css`
  width: ${theme.icon.size.md};
  height: ${theme.icon.size.md};
`;

export const Icons = {
  Dashboard: styled(DashboardSVG)(iconStyle),
  Subscription: styled(SubscriptionSVG)(iconStyle),
  Loan: styled(LoanSVG)(iconStyle),
  Library: styled(LibrarySVG)(iconStyle),
  Profile: styled(ProfileSVG)(iconStyle),
  Language: styled(LanguageSVG)(iconStyle),
  Contact: styled(ContactSVG)(iconStyle),
  Logout: styled(LogoutVG)(iconStyle),
};

export const MenuRowWrapper = styled.div<{active: boolean}>`
  display: flex;
  align-items: center;
  padding: 0px 16px 0px 12px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 48px;
    width: 4px;
    background-color: ${({theme, active}) =>
      active ? theme.color.primary : 'transparent'};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const MenuRowContent = styled.div<{active: boolean}>`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: ${({theme}) =>
    `${theme.padding.desktop.sm} ${theme.padding.desktop.md}`};
  gap: ${({theme}) => theme.gap.desktop.md};
  background-color: ${({theme, active}) =>
    active ? theme.color.surface.white : 'transparent'};
  border-radius: ${({theme}) => theme.border.radius.md};

  &:hover {
    background-color: ${({theme, active}) =>
      active ? theme.color.primary_10 : theme.color.surface.background};
    & > p {
      color: ${({theme, active}) =>
        active ? theme.color.white : theme.color.neutral.primary};
    }
    & > div > svg {
      color: ${({theme, active}) =>
        active ? theme.color.white : theme.color.neutral.primary};
    }
    cursor: pointer;
  }
`;

export const IconWrapper = styled(IconWrapperStyle)<{active: boolean}>`
  color: ${({theme, active}) =>
    active ? theme.color.primary : theme.color.neutral.grey_800};
`;

export const MenuText = styled(TextDefault)<{active: boolean}>`
  color: ${({theme, active}) =>
    active ? theme.color.primary : theme.color.neutral.grey_800};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`;

export const StyledAction = styled.div`
  width: 100%;
`;
